import React from "react";

import { Typography } from "@material-ui/core";

import TrimmedText from "components/TrimmedText";

import { TitleContainer, LeftContent, RightContent } from "./styles";

type Props = {
  title: string;
  badge?: React.ReactNode;
  controls?: React.ReactNode;
  leftControls?: React.ReactNode;
  className?: any;
};

const Title = ({ title, controls, className, leftControls }: Props) => {
  return (
    <TitleContainer className={className}>
      <LeftContent>
        <TrimmedText lines={1} text={title}>
          <Typography variant="h1" color="textPrimary">
            {title}
          </Typography>
        </TrimmedText>
        {leftControls}
      </LeftContent>
      {controls && <RightContent>{controls}</RightContent>}
    </TitleContainer>
  );
};

export default Title;
